import React, { useEffect, useState } from 'react'
import api from '../api'
import { Activity, RefreshCw, Server, Bot, Terminal, Clock3 } from 'lucide-react'
import { Card, PageHeader, Button, Badge, Alert, EmptyState } from '../components/ui'

// Halaman "Service" (2026-07-30) -- daftar cron/job periodik milik APLIKASI INI (bukan seluruh
// server, lihat catatan arsitektur di server/routes/systemCron.js): in-process admin-app,
// in-process admin-bot, dan cron host (update_worker.py, di luar Docker). Status "terakhir jalan"
// murni in-memory sisi server (cronRegistry.js) -- reset tiap container restart, SENGAJA (lihat
// komentar di sana kenapa bukan tabel DB baru).
function relTime(iso) {
  if (!iso) return 'belum pernah sejak restart'
  const diffMs = Date.now() - new Date(iso).getTime()
  const min = Math.round(diffMs / 60000)
  if (min < 1) return 'baru saja'
  if (min < 60) return `${min} menit lalu`
  const hr = Math.round(min / 60)
  if (hr < 24) return `${hr} jam lalu`
  return `${Math.round(hr / 24)} hari lalu`
}

function fmtDate(iso) {
  if (!iso) return '-'
  return new Date(iso).toLocaleString('id-ID', { dateStyle: 'medium', timeStyle: 'short' })
}

function statusBadge(status) {
  if (status === 'ok') return <Badge tone="success">Normal</Badge>
  if (status === 'error') return <Badge tone="danger">Error terakhir jalan</Badge>
  if (status === 'terlambat') return <Badge tone="danger">Terlambat / macet</Badge>
  if (status === 'unknown') return <Badge tone="danger">Tidak terjangkau</Badge>
  if (status === 'dimatikan') return <Badge tone="neutral">Dimatikan (LAB)</Badge>
  return <Badge tone="neutral">Belum pernah jalan</Badge>
}

function JobRow({ j }) {
  return (
    <div style={{
      padding: '14px 16px', borderBottom: '1px solid var(--border)',
      display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 14, flexWrap: 'wrap'
    }}>
      <div style={{ flex: '1 1 260px', minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
          <span style={{ fontWeight: 700, fontSize: 13.5 }}>{j.nama}</span>
          {statusBadge(j.terakhirStatus)}
        </div>
        <p style={{ fontSize: 12.5, color: 'var(--text-muted)', margin: 0, lineHeight: 1.5 }}>{j.deskripsi}</p>
        {j.terakhirStatus === 'error' && j.terakhirPesan && (
          <p style={{ fontSize: 11.5, color: 'var(--danger)', marginTop: 4 }}>{j.terakhirPesan}</p>
        )}
        {j.terakhirStatus === 'unknown' && j.terakhirPesan && (
          <p style={{ fontSize: 11.5, color: 'var(--danger)', marginTop: 4 }}>{j.terakhirPesan}</p>
        )}
      </div>
      <div style={{ flex: '0 0 200px', textAlign: 'right', fontSize: 11.5, color: 'var(--text-faint)' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5 }}>
          <Clock3 size={11} /> {j.jadwalHuman}
        </div>
        <div style={{ marginTop: 3 }} title={fmtDate(j.terakhirJalanAt)}>
          Terakhir jalan: {relTime(j.terakhirJalanAt)}
        </div>
        {j.terakhirDurasiMs != null && <div style={{ marginTop: 2 }}>Durasi: {j.terakhirDurasiMs} ms</div>}
      </div>
    </div>
  )
}

function Kelompok({ icon: Icon, label, jobs }) {
  if (!jobs || jobs.length === 0) return null
  return (
    <Card style={{ marginBottom: 18, padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '14px 16px', borderBottom: '1px solid var(--border)', display: 'flex', alignItems: 'center', gap: 8, background: 'var(--surface-alt, transparent)' }}>
        <Icon size={15} color="var(--brand)" />
        <span style={{ fontWeight: 700, fontSize: 13.5 }}>{label}</span>
      </div>
      {jobs.map(j => <JobRow key={j.kode} j={j} />)}
    </Card>
  )
}

export default function Service() {
  const [data, setData] = useState(null)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  async function load() {
    setError('')
    try {
      const res = await api.get('/system-cron')
      setData(res.data)
    } catch (e) {
      setError(e.response?.data?.message || 'Gagal memuat status cron')
    } finally { setLoading(false) }
  }

  useEffect(() => { load() }, [])

  if (loading) return null

  return (
    <div>
      <PageHeader
        title="Service"
        subtitle="Cron/job periodik yang berjalan untuk aplikasi ini (admin-app, admin-bot, & worker host)"
        actions={<Button variant="ghost" icon={RefreshCw} onClick={load}>Muat Ulang</Button>}
      />

      {error && <Alert type="error">{error}</Alert>}

      {data && (
        <>
          <Kelompok icon={Server} label="Container admin-app" jobs={data.app} />
          <Kelompok icon={Bot} label="Container admin-bot" jobs={data.bot} />
          <Kelompok icon={Terminal} label="Host server (di luar Docker)" jobs={data.host} />
        </>
      )}

      {data && data.app.length === 0 && data.bot.length === 0 && data.host.length === 0 && (
        <EmptyState icon={Activity} title="Belum ada data cron" hint="Coba muat ulang halaman ini" />
      )}
    </div>
  )
}
